import { Container } from './Container';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const faqs = [
  { question: 'How does pricing work?', answer: 'Free to build, preview, and tweak. £39 once when you publish a game live. £149 for a 5-game pack if you run multiple campaigns. No subscription, no card needed to start.' },
  { question: 'What does £39 unlock?', answer: 'Everything: shareable link, QR code, live leaderboard, full analytics, CTA button with click tracking, and lead capture. There are no tiers and no extra paywalls.' },
  { question: 'Can I use SmilesFlow for client campaigns?', answer: 'Yes. Build a branded game for one client, share it by link or QR code, then reuse the campaign structure for the next client, launch, or activation.' },
  { question: 'Can the game use my client branding?', answer: 'Yes. The game carries your client logo, colours, CTA, and campaign copy. SmilesFlow attribution stays minimal; full white-label is not part of the current package.' },
  { question: 'Can I edit a game after I publish it?', answer: 'Yes, free forever. The same public URL keeps working. Re-publishing updates the live game in place and never charges another credit.' },
  { question: 'Can I use this on Instagram?', answer: 'Yes. Publish the game, copy the link, and use it in a story, bio, DM, email, or post-click campaign. Players open it in their phone browser.' },
  { question: 'How does lead capture work?', answer: 'Players enter their name to join the leaderboard and can optionally submit their email. Add a post-game CTA button to send them to a booking link, offer, or reveal code.' },
  { question: 'Do players need to download an app?', answer: 'No. Players open the game link or scan a QR code and play instantly in their phone browser. No app, no player account.' },
  { question: 'What games are available?', answer: 'Nine formats: Snake, Lane Dash, Jump Runner, Sky Bounce, Flap & Fly, Quiz Rush, Complete the List, Minigolf, and Stacker. All carry your logo as the in-game collectible and use your brand colours.' },
  { question: 'What if something goes wrong with payment?', answer: 'Refunds are handled by email at support@smilesflow.com. We aim to reply within one working day.' },
];

export function FAQ() {
  return (
    <section id="faq" className="sf-section sf-section-trust py-10 sm:py-16">
      <Container>
        <div className="mx-auto max-w-4xl lg:text-center mb-8">
          <h2 className="font-arcade text-2xl tracking-tight text-gch-accent sm:text-3xl">Frequently asked questions</h2>
          <p className="mt-3 text-base text-gch-text-secondary">
            Have a different question?{' '}
            <a href="mailto:support@smilesflow.com" className="font-semibold text-gch-accent hover:text-gch-accent/80 transition-colors">Email us</a>
          </p>
        </div>
        <div className="mx-auto max-w-5xl">
          <dl className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="gch-card border border-white/10 rounded-xl overflow-hidden min-w-0">
                {({ open }) => (
                  <>
                    <dt>
                      <DisclosureButton className={`flex w-full items-start justify-between gap-3 text-left pt-5 pb-4 px-4 sm:px-5 transition-colors ${open ? 'rounded-t-xl' : 'rounded-xl'}`}>
                        <span className="text-base font-semibold text-white pr-2">{faq.question}</span>
                        <ChevronDownIcon
                          className={`h-5 w-5 shrink-0 text-gch-accent transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
                          aria-hidden
                        />
                      </DisclosureButton>
                    </dt>
                    <DisclosurePanel as="dd" className="px-4 pb-4 sm:px-5 sm:pb-5 pt-0">
                      <p className="text-base text-gch-text-secondary leading-relaxed">{faq.answer}</p>
                    </DisclosurePanel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </Container>
    </section>
  );
}
